import BigDecimal from "big.js";
import getPriceBreakForQuantity from "./getPriceBreakForQuantity";

BigDecimal.RM = 1; // this sets BigDecimal's rounding method to ROUND_HALF_UP

const configureVendorOptions = (
  mpId: number,
  quantity: number,
  vendorOptions: VendorOptionFromServer[],
): VendorOptionState[] => {
  return vendorOptions.map((vendorOption) => {
    const configuredPriceBreaks: VendorOptionPriceBreakState[] = vendorOption.priceBreaks.map((pb) => {
      return {
        ...pb,
        unitPrice: pb.unitPrice,
      };
    });

    const chosenPriceBreak = getPriceBreakForQuantity(quantity, configuredPriceBreaks);

    // getPriceBreakForQuantity can return a minQty that is above the quantity if a proper price break cannot
    // be found.  We need to make sure to use minQty for the following math if it is greater than quantity.
    const priceMultiplier = quantity >= chosenPriceBreak.minQty ? quantity : chosenPriceBreak.minQty;
    const minQuantities = vendorOption.priceBreaks.map((pb) => pb.minQty);

    const configuredVendorOption = {
      ...vendorOption,
      standardShipping: vendorOption.standardShipping,
      freeShippingGap: vendorOption.freeShippingGap,
      heavyShipping: vendorOption.heavyShipping,
      isAuthorizedDistributor: vendorOption.badgeId && vendorOption.badgeId > 0 ? true : false,
      chosenPriceBreakUnitPrice: chosenPriceBreak.unitPrice,
      chosenPriceBreakMinQty: chosenPriceBreak.minQty,
      chosenPriceBreakId: chosenPriceBreak.pmId,
      highestVendorOptionPrice: 0,
      productSubTotal: chosenPriceBreak.unitPrice * priceMultiplier,
      priceBreaks: configuredPriceBreaks,
      vendorRating: vendorOption.vdrGeneralAverageRatingSum / vendorOption.vdrNumberOfGeneralRatings,
      minimumQuantityPurchasable: Math.min(...minQuantities),
    };

    const productGrandTotal = (() => {
      let total = new BigDecimal(configuredVendorOption.productSubTotal);
      if (vendorOption.standardShippingStatus === StandardShippingStatus.STANDARD_SHIPPING) {
        total = total.plus(configuredVendorOption.standardShipping);
      }
      if (vendorOption.heavyShippingStatus === HeavyShippingStatus.HAS_KNOWN_HEAVY_SHIPPING) {
        total = total.plus(configuredVendorOption.heavyShipping);
      }
      return Number(total);
    })();

    return {
      ...configuredVendorOption,
      productGrandTotal,
    };
  });
};

export default configureVendorOptions;

export enum StandardShippingStatus {
  STANDARD_SHIPPING = "STANDARD_SHIPPING",
  NO_ADDITIONAL_SHIPPING = "NO_ADDITIONAL_SHIPPING",
  FREE_SHIPPING = "FREE_SHIPPING",
}

export enum HeavyShippingStatus {
  NO_HEAVY_SHIPPING = "NO_HEAVY_SHIPPING",
  HAS_KNOWN_HEAVY_SHIPPING = "HAS_KNOWN_HEAVY_SHIPPING",
  HAS_UNKNOWN_HEAVY_SHIPPING = "HAS_UNKNOWN_HEAVY_SHIPPING",
  NO_SURCHARGE_MESSAGE = "NO_SURCHARGE_MESSAGE",
}
